"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .config(function ($stateProvider, $urlRouterProvider) {
    $stateProvider.state("main.productsegment", {
      url: "productsegment",
      resolve: {
        list: [
          "$stateParams",
          "ProductSegment",
          function ($stateParams, ProductSegment) {
            return ProductSegment.list().$promise;
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/SWFlow/productsegment/views/productsegment.list.html",
          controller: "productsegmentListCtrl",
          controllerAs: "vm",
        },
      },
    });

    $stateProvider.state("main.productsegment-edit", {
      url: "productsegment/:id",
      resolve: {
        model: [
          "$stateParams",
          "ProductSegment",
          function ($stateParams, ProductSegment) {
            if ($stateParams.id) {
              return ProductSegment.get({ id: $stateParams.id }).$promise;
            }

            return {};
          },
        ],
      },
      views: {
        main: {
          templateUrl:
            "/modules/SWFlow/productsegment/views/productsegment.edit.html",
          controller: "productsegmentEditCtrl",
          controllerAs: "vm",
        },
      },
    });
  });
